import React from 'react';
import ButtonV2 from '@components/ButtonV2/ButtonV2';
import { UIConstants } from '@constants/UIConstants';
import { Wrapper, AlertTitle, AlertDetails, ContentWrapper, AlertInfoWrapper, CloseIcon } from './ModalAlert.styled';
import { AmplifyLogs } from '@constants';
import EnrollmentText from '@components/EnrollmentText/EnrollmentText';

interface ModalAlertProps {
    title?: string;
    details: string;
    image?: string;
    buttonText: string;
    handleClose?: (arg0: string) => void;
}

export const ModalAlert: React.FC<ModalAlertProps> = ({ title, details, image, buttonText, handleClose }) => {
    const { closeIconWhite, enrollNow, confirmationDetails, confirmationHeading } = UIConstants;
    const { type, action, description } = AmplifyLogs.docErrAlertBtn;

    const handleButtonClose = () => {
        handleClose(buttonText === enrollNow ? 'closeEnroll' : 'close');
    };
    return (
        <ContentWrapper>
            {title && (
                <Wrapper>
                    {title.includes(confirmationHeading) ? <div></div> : null}
                    <AlertTitle>{title}</AlertTitle>
                    <CloseIcon id="closeBtn" data-testid="closeBtn" src={closeIconWhite} alt="close" onClick={handleButtonClose} />
                </Wrapper>
            )}
            <AlertInfoWrapper>
                {image && <img src={image} alt="close" height="28px" />}
                <AlertDetails>{details === confirmationDetails ? <EnrollmentText /> : details}</AlertDetails>
            </AlertInfoWrapper>

            <ButtonV2
                data-testid="ButtonV2"
                onClick={() => handleClose(buttonText)}
                text={buttonText}
                id={`${buttonText}Btn`}
                themeType="primary"
                eventAttributes={{ type, action, description }}
            />
        </ContentWrapper>
    );
};
